import Quill from 'quill';

const Inline = Quill.import('blots/inline');

class formatParam extends Inline {
  static create(value) {
    const node = super.create();
    node.innerText=`{${value}}`
    return node;
  }

  /*static formats(node) {
    return node;
  }*/
}
formatParam.blotName = 'formatParam';
formatParam.tagName = 'b';

export default formatParam;



// WEBPACK FOOTER //
// ./src/components/main/emailTemplate/formatParam.js